module.exports = __webpack_public_path__ + "img/d- (10).67255773.png";